const healthUnitInformationSchema = {
  healthUnitCnpj: {
    displayName: 'CNPJ da unidade',
    notAvailable: 'CNPJ da unidade não informado',
    mask: 'cnpj',
    canCopy: false,
  },
  healthUnitCnes: {
    displayName: 'CNES da unidade',
    notAvailable: 'CNES da unidade não informado',
    canCopy: false,
  },
  healthUnitName: {
    displayName: 'Nome da unidade de saúde',
    notAvailable: 'Nome da unidade de saúde não informado',
  },
  healthUnitPhone: {
    displayName: 'Telefone',
    notAvailable: 'Telefone não informado',
    mask: 'phone',
  },
  healthUnitType: {
    displayName: 'Tipo da unidade de saúde',
    type: 'string',
    notAvailable: 'Tipo da unidade de saúde não informado',
  },
  healthUnitSubtype: {
    displayName: 'Subtipo da unidade de saúde',
    type: 'string',
    notAvailable: 'Subtipo da unidade de saúde não informado',
  },
  healthUnitPostalCode: {
    displayName: 'CEP',
    notAvailable: 'CEP não informado',
    mask: 'cep',
  },
  healthUnitStreetName: {
    displayName: 'Rua',
    notAvailable: 'Rua não informada',
  },
  healthUnitStreetNumber: {
    displayName: 'Número',
    notAvailable: 'Número não informado',
  },
  healthUnitComplement: {
    displayName: 'Complemento',
    notAvailable: 'Complemento não informado',
  },
  healthUnitReferencePoint: {
    displayName: 'Ponto de referência',
    notAvailable: 'Ponto de referência não informado',
  },
  healthUnitNeighborhood: {
    displayName: 'Bairro',
    notAvailable: 'Bairro não informado',
  },
  healthUnitMunicipality: {
    displayName: 'Município',
    notAvailable: 'Município não informado',
  },
}

export default healthUnitInformationSchema